import { getEmbarcacaoVazaoBombas } from "./embarcacoes.gateway";
import { isEmbarcacaoVazaoBombasEmpty } from "./embarcacoes.types";
import type { EmbarcacaoVazaoBombas, EmbarcacaoVazaoBombasState } from "./embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

export const VAZAO_BOMBAS_SESSION_EXPIRED_MESSAGE =
  "Sua sessão expirou. Entre novamente para consultar os detalhes da embarcação.";
export const VAZAO_BOMBAS_FORBIDDEN_MESSAGE =
  "Você não tem permissão para consultar os detalhes desta embarcação.";
export const VAZAO_BOMBAS_NOT_FOUND_MESSAGE = "Embarcação não encontrada.";
export const VAZAO_BOMBAS_ERROR_MESSAGE =
  "Não foi possível carregar a Vazão das Bombas da embarcação.";

const VAZAO_BOMBAS_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoVazaoBombas> = {
  load: getEmbarcacaoVazaoBombas,
  isEmpty: isEmbarcacaoVazaoBombasEmpty,
  messages: {
    sessionExpired: VAZAO_BOMBAS_SESSION_EXPIRED_MESSAGE,
    forbidden: VAZAO_BOMBAS_FORBIDDEN_MESSAGE,
    notFound: VAZAO_BOMBAS_NOT_FOUND_MESSAGE,
    error: VAZAO_BOMBAS_ERROR_MESSAGE,
  },
};

interface UseEmbarcacaoVazaoBombasResult extends EmbarcacaoVazaoBombasState {
  reload: () => void;
}

/**
 * Consulta a Vazão das Bombas da embarcação pedida (AC4). Somente leitura:
 * nenhuma escrita é disparada na abertura nem no fechamento do modal.
 */
export function useEmbarcacaoVazaoBombas(id: string): UseEmbarcacaoVazaoBombasResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, VAZAO_BOMBAS_QUERY);

  return { ...state, vazaoBombas: data };
}
